import React from "react";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type BackButtonProps = {
	readonly onBack: () => void;
	readonly show: boolean;
};

function BackButton({ onBack, show }: BackButtonProps) {
	const t = useTranslator();
	if (!show) {
		return null;
	}

	return (
		<button
			type="button"
			onClick={onBack}
			className="get-started-back-button"
			aria-label={t("Go back to previous step")}
		>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M21 12H5M12 19L5 12L12 5"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	);
}

export default BackButton;
